import React from 'react';

import cx from 'classnames';

import QuantityInput from 'components/form/QuantityInput';
import Slider from 'components/form/Slider';
import Label from 'components/general/Label';
import { S, H5 } from 'components/typography';

import styles from './ReservableFeatureSlider.scss';

type Props = {
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  TooltipComponent: React.ReactNode;
  value: number;
  label: string;
  description?: string;
  min: number;
  max: number;
  step?: number;
  summary?: string;
  // Reservable's own label is a bold H5 heading; callers embedding this
  // slider next to plain-text labels (e.g. Update) can opt out.
  boldLabel?: boolean;
  formatLabel?: (value: number) => string;
  onChange: (value: number) => void;
};

export default function ReservableFeatureSlider({
  className,
  style,
  disabled,
  TooltipComponent,
  value,
  label,
  description,
  min,
  max,
  step,
  summary,
  boldLabel = true,
  formatLabel,
  onChange,
}: Props) {
  return (
    <fieldset
      className={cx(styles.ReservableFeatureSlider, className)}
      style={style}
      data-disabled={disabled}
    >
      <Label TooltipComponent={TooltipComponent} className={styles.label}>
        {boldLabel ? <H5 mb={2}>{label}</H5> : label}
      </Label>
      {description && <S>{description}</S>}
      <div className={styles.row}>
        <Slider
          className={styles.slider}
          // @ts-expect-error ts-migrate(2322) FIXME: Type '(value: number) => void' is not assignable t... Remove this comment to see the full error message
          onChange={onChange}
          min={min}
          max={max}
          formatLabel={formatLabel}
          step={step}
          value={Number(value)}
        />
        {/* @ts-expect-error ts-migrate(2741) FIXME: Property 'iconType' is missing in type '{ style: {... Remove this comment to see the full error message */}
        <QuantityInput
          style={{ border: 'none' }}
          className={styles.input}
          disabled={disabled}
          onChange={onChange}
          quantity={value}
          min={min}
          max={max}
        />
        {summary && <S className={styles.summary}>{summary}</S>}
      </div>
    </fieldset>
  );
}
